var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mk-conntent section pt-2 pb-0"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column mk-content-wrap is-12"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }